let holds = 0

export function forceLogoutOnAuthFailure(): () => void {
  holds += 1
  let released = false
  return () => {
    if (released) return
    released = true
    holds -= 1
  }
}

export function isLogoutOnAuthFailureForced(): boolean {
  return holds > 0
}
